import React, {Component} from "react";
import axios from "axios";
import store from '../store';

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/buyer/`
})
const itemApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/seller/GigsApi/`
})
const userApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/user/UserAPI/`
})


class NewOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            NewOrders:[],
        }
    }
    componentDidMount(){
        this.getNewOrders();
      }
      
    getNewOrders = async () => {
        let data = await api.get(`SellerOrdersAPI/${store.getState().auth.user.id}/`).then(({data})=>data);
        data.map(a =>
            this.get(a,data)
            ) 
    }
    get = async(a,data) => {
        let data2 = await userApi.get(`/${a.buyer}/`).then(({data})=>data);
        a.buyer = data2[0].first_name+' '+data2[0].last_name
        a.completed_orders = a.completed_orders
        this.setState({NewOrders:data})
    }
    
    
    updateOrderStatus = async(id,status) => {
        let data = new FormData();
        data.append('status',status );
        if(status === 'confirmed'){
            data.append('orderStartTime',new Date().toJSON())
        }
        else if(status === 'shipped'){
            data.append('orderCompletedTime',new Date().toJSON())
        }
        await api.put(`OrdersAPI/${id}/`, data);
        this.getNewOrders();
    }

    markOrderAsShipped = async(id,status) => {
        let data = new FormData();
        data.append('status',status );
        data.append('orderCompletedTime',new Date().toJSON())
        await api.put(`OrdersAPI/${id}/shipped/`, data);
        this.getNewOrders();
    }
   
    render() {
    return(
    <>
        <div className='container mt-5 pt-5 mx-5 px-5'>
            <h1>{this.props.status.toUpperCase() }</h1><br/>
            <hr/>
            <div className='container mx-2 w3-light-gray'>
                
                <table className="table">
                <thead>
                    <tr>
                    <th style={{width:'30%'}} >Items</th>
                    <th style={{width:'30%'}}>Address</th>
                    <th style={{width:'10%'}}>Name</th>
                    <th style={{width:'10%'}}>Mobile</th>
                    <th style={{width:'5%'}}>Price</th>
                    { this.props.status === 'shipped' || this.props.status === 'completed'  ? null : 
                    <th style={{width:'10%'}}>Action</th>
                    }
                    </tr>
                </thead>
                <tbody>
                {this.state.NewOrders.map(a =>
                
                a.status === this.props.status || (this.props.status === 'shipped' && a.status=== 'completed' ) ?
                    <tr key={a.id}>
                        <td >
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th>Quantity</th>
                                    </tr>
                                </thead>
                                {a.order_items.map(order_item =>
                                    <tr>
                                        <td>{order_item.item.title}</td>
                                        <td>{order_item.quantity}</td>
                                    </tr>
                                )}
                                <tbody></tbody>
                            </table>    
                            
                        </td> 
                        <td>{a.address}</td>
                        <td>{a.buyer}</td>
                        <td>{a.mobile}</td>
                        <td>{a.price}</td>
                        {a.status === 'new order' ?
                        <td><button title='Accept Order' style={{border: 'none',backgroundColor: 'transparent'}} onClick={() => this.updateOrderStatus(a.id,'confirmed')} > <i className='fa fa-check-square' style={{fontSize:'24px', color:'#FFC312'}}></i> </button><span> </span>
                        <button title='Reject Order' style={{border: 'none',backgroundColor: 'transparent'}} onClick={() => this.updateOrderStatus(a.id,'rejected')} > <i className='fa fa-times-circle' style={{fontSize:'24px', color:'red'}}></i> </button>
                        </td> : a.status === 'confirmed' ? 
                        <td>
                            <button title='Order is Shipped' style={{border: 'none',backgroundColor: 'transparent'}} onClick={() => {this.markOrderAsShipped(a.id,'shipped');}} > <i className='fa fa-truck' style={{fontSize:'28px', color:'#FFC312'}}></i> </button>
                        </td>
                        :
                        null}
                    </tr>
                :
                    null
                )}
                        
                </tbody>
                </table>
                <br/>
            </div>
        </div>
       
       
    </>
    )
    }
} 
export default NewOrders;